var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('secition-card', _vm._b({
    attrs: {
      "title": "방문자"
    }
  }, 'secition-card', {
    titleActionProps: {
      to: '/console/statistics/visitors'
    },
    loading: _vm.loading
  }, false), [_c('statistics-chart-visits', _vm._b({}, 'statistics-chart-visits', {
    statistics: _vm.statistics,
    searchDateValue: _vm.searchDateValue
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }